module.exports = __webpack_public_path__ + "media/logos/guardant-logo-with-text-7a5a439e.svg";